<template>
  <div class="w-full max-w-270 text-app-color">
    <div class="w-full p-15 pt-10 pb-40 rounded-20 " :class="isDarkMode ? 'bg-sidebar' : 'bg-green-600'">
      <div class="text-center mt-30">
        <p class="text-26 font-semibold">PRO.</p>
        <p class="text-14">Get all features and <br> everything unlimited.</p>
        <div class="text-center mt-20">
          <div class="flex items-start justify-center -ml-10">
            <span>$</span>
            <span class="text-35 font-bold">{{ price }}</span>
          </div>
          <p class="leading-0">per month</p>
        </div>
      </div>

      <div class="text-center mt-35">
        <button
          class="border-2 transition-color duration-300 rounded-12 py-12 font-bold min-w-150"
          :class="btnClasses"
          :disabled="!isFreePlan && !isExpired"
          @click="upgrade"
        >
          {{ btnTitle }}
        </button>
      </div>

      <div class="flex justify-center mt-30">
        <div>
          <div class="flex items-center mt-20">
            <i class="icon-arr-left text-20 font-bold mr-5" />
            <p class="font-semibold">Everything in FREE plus...</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Unlimited</span> spaces</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Unlimited</span> pages</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Unlimited</span> storage</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Week</span> planner</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Export</span> pages</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Beautiful</span> themes</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    billMonthly: Boolean
  },

  setup (props) {
    const { state, getters, commit, dispatch } = useStore()

    const user = computed(() => state.profile.user)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')
    const isFreePlan = computed(() => getters.isFreePlan)
    const isExpired = computed(() => getters.isExpired)
    const currentPlan = computed(() => getters.currentPlan)
    const proPlanMonthly = computed(() => getters.proPlanMonthly)
    const proPlanYearly = computed(() => getters.proPlanYearly)

    const price = computed(() => {
      if (!isFreePlan.value) {
        return parseInt(currentPlan.value.pricePerMonth)
      }
      return props.billMonthly ? parseInt(proPlanMonthly.value.pricePerMonth) : parseInt(proPlanYearly.value.pricePerMonth)
    })
    const btnTitle = computed(() => {
      if (isExpired.value) return 'RENEW'
      return isFreePlan.value ? 'UPGRADE' : 'Your current plan'
    })

    const btnClasses = computed(() => {
      if (btnTitle.value === 'Your current plan') {
        return 'px-26 bg-grey-250 border-transparent opacity-50'
      } else {

      }
      return isDraculaTheme.value
        ? 'bg-notebooks-dracula-link hover:bg-canvas border-notebooks-dracula-link'
        : isDarkMode.value
          ? 'bg-link-color hover:bg-canvas hover:text-link-color border-link-color px-52'
          : 'border-blue-dark hover:bg-blue-dark hover:text-white px-52'
    })

    function upgrade () {
      const currentPlanId = currentPlan.value.provider === 'Stripe' ? currentPlan.value.id : null

      if (isFreePlan.value || (isExpired.value && currentPlanId)) {
        const planId = props.billMonthly ? proPlanMonthly.value.id : proPlanYearly.value.id

        dispatch('upgradePlan', {
          planId: isExpired.value ? currentPlanId : planId,
          userId: user.value.id
        }).then(res => {
          commit('loading', true)

          const stripe = window.Stripe(process.env.VUE_APP_STRIPE)

          stripe.redirectToCheckout({ sessionId: res })
            .then(() => {})
            .catch(() => commit('loading', false))
        })
      }
    }

    return {
      // computed
      user,
      isDarkMode,
      isDraculaTheme,
      isFreePlan,
      isExpired,
      price,
      btnTitle,
      btnClasses,
      // function
      upgrade
    }
  }
})
</script>
